import { Badge } from '@/components/ui/Badge/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Skeleton } from '@/components/ui/skeleton';
import { Ticket } from '@certhon/models';
import React from 'react';
import { FieldComponentProps } from './types';

type TicketStatus = Ticket['status'];

const FieldView = ({ value }: { value: TicketStatus }) => {
  const label = value === 'opened' ? 'Open' : 'Closed';
  const variant = value === 'opened' ? 'destructive' : 'positive';
  return (
    <Badge variant={variant} className="capitalize">
      {label}
    </Badge>
  );
};

export const TicketStatusField: React.FC<FieldComponentProps> = ({
  formMode,
  controllerField,
  field,
}) => {
  if (formMode === 'loading') {
    return <Skeleton className="h-8 w-24" />;
  }

  if (formMode === 'edit') {
    return (
      <Select
        onValueChange={controllerField.onChange}
        value={controllerField.value}
      >
        <SelectTrigger size="sm">
          <SelectValue placeholder={field.meta.label} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="opened">Opened</SelectItem>
          <SelectItem value="closed">Closed</SelectItem>
        </SelectContent>
      </Select>
    );
  }

  return <FieldView value={controllerField.value} />;
};
